import { Helper, DateTimeUtil } from "@neumetric/blueprint-lib/utility";

const AuditStatus = [
  { id: "Pending", label: "Pending", dotIconName: "pending" },
  { id: "Evaluating", label: "Evaluating", dotIconName: "future" },
  { id: "Revision", label: "Revision", dotIconName: "review" },
  { id: "Submitted", label: "Submitted", dotIconName: "future" },
  { id: "Evaluated", label: "Evaluated", dotIconName: "future" },
  { id: "Complete", label: "Complete", dotIconName: "complete" },
];

const mapAuditListRow = (row) => {
  const statusOption = AuditStatus.find((_) => _.id === row?.status);
  return {
    ...row,
    gap_serverity: row?.gap_serverity
      ? { id: row?.gap_serverity, label: row?.gap_serverity }
      : null,
    status_obj: statusOption ? statusOption : AuditStatus[0],
    status: statusOption ? row.status : "Pending",
    start_date: row?.date,
    actions: "Details",
    gap_score: row?.gap_score ? parseInt(row?.gap_score) : 0,
    assessor: (row?.assessor || []).join("<br/>"),
    auditee: (row?.auditee || []).join("<br/>"),
    actual_end_date: row?.actual_end_date
      ? new DateTimeUtil(row?.actual_end_date).toString("ddd, DD-MMM-YYYY")
      : "Audit in progress.",
    gaps: Math.round(row.gaps),
  };
};
export const getAuditState = (state) => state.audit;

export const mapAuditList = (rows = []) => rows.map(mapAuditListRow);

const formatDate = (iso) =>
  iso ? new DateTimeUtil(iso).toString("ddd, DD-MMM-YYYY") : "";

const joinNames = (arr, path) => {
  // path examples:
  // (x) => x?.auditor?.firstname
  // (x) => x?.auditee?.firstname
  return (arr || []).map(path).filter(Boolean).join(", ");
};

export const mapAuditDetails = (res) => {
  if (!res) return null;

  return {
    title: res.title || "",
    model: res?.lib1_model?.title || "",
    desc: res?.desc || res?.lib1_model?.desc || "",

    audit_type: res?.audit_type || "",
    status: res?.audit_status || "",

    start_date: formatDate(res?.start_date),
    end_date: formatDate(res?.end_date),
    actual_start_date: formatDate(res?.actual_start_date),
    actual_end_date: formatDate(res?.actual_end_date),

    governor: joinNames(res?.asmt_assessors, (x) => x?.auditor?.firstname),
    user: joinNames(res?.asmt_auditees, (x) => x?.auditee?.firstname),
  };
};
export const mapControlComments = (asmt_cntrl_resp_comments) => {
  const comments = [];
  const evidences = [];
  asmt_cntrl_resp_comments.forEach((comment) => {
    const creator = Helper.getUserObject(comment.creator);
    if (
      comment.auditee_resp_comment &&
      comment.auditee_resp_comment.length > 0
    ) {
      comments.push({
        comment: comment.auditee_resp_comment,
        datetime: comment.created_at,
        creator: creator,
      });
    }
    if (comment.evidence_file_name && comment.evidence_file_name.length > 0) {
      evidences.push({
        ...comment,
        creator: creator,
        updater: Helper.getUserObject(comment.updater),
        created_at: new DateTimeUtil(comment.created_at).toString(
          "ddd, DD-MMM-YYYY hh:mm",
        ),
        updated_at: new DateTimeUtil(comment.updated_at).toString(
          "ddd, DD-MMM-YYYY hh:mm",
        ),
      });
    }
  });
  return { comments, evidences };
};
export const mapAuditToControl = (iControl) => {
  const control = { ...iControl };
  if (
    Array.isArray(control.asmt_cntrl_resp_comments) &&
    control.asmt_cntrl_resp_comments.length > 0
  ) {
    const { comments, evidences } = mapControlComments(
      control.asmt_cntrl_resp_comments,
    );
    control.comments = comments;
    control.evidences = evidences;
  }
  if (control.external_ref) {
    control.external_ref = control.external_ref.replace(
      /\((https?:\/\/[^\s)]+)\)/g,
      (_, url) =>
        `<a href="${url}" class="ml-4" target="_blank" rel="noopener noreferrer"><span class="nm-icon nm-icon-open-link text-action fs-12"></span></a><br/>`,
    );
  }
  return control;
};
export const getStatusProperty = (asmt, currentUser) => {
  const isAssessor = asmt.asmt_assessors.some(
    (assessor) => assessor.assessor_id === currentUser.id,
  );
  return isAssessor ? "auditor_ctrl_status" : "auditee_ctrl_status";
};
export const mapAudit = (asmt, currentUser) => {
  const groupsMap = {},
    sectionMap = {};
  asmt.asmt_groups.forEach((group) => {
    groupsMap[group.id] = { ...group };
  });
  asmt.asmt_sections.map((section) => {
    sectionMap[section.id] = { ...section };
  });
  asmt.controlMap = {};
  asmt.countMap = {
    department: {},
    priority: {},
    score: {},
    status: {},
    response: {},
  };
  const statusProperty = getStatusProperty(asmt, currentUser);
  asmt.resultOptions = [];
  asmt.controlIdIndexMap = {};
  const resultMap = {};
  asmt.asmt_cntrls.forEach((control, index) => {
    if (control.asmt_cntrl_resp_options) {
      control.asmt_cntrl_resp_options.forEach((option) => {
        if (option && !resultMap[option.result]) {
          resultMap[option.result] = true;
          asmt.resultOptions.push({ id: option.result, label: option.result });
        }
      });
    }
    control.section = sectionMap[control.asmt_section_id];
    control.group = groupsMap[control.section.asmt_group_id];
    control.status = control[statusProperty] || "Pending";
    asmt.controlMap[control.id] = control;
    asmt.controlIdIndexMap[control.id] = index;
    asmt.countMap.department[control.dept_name] =
      (asmt.countMap.department[control.dept_name] || 0) + 1;
    asmt.countMap.priority[control.priority] =
      (asmt.countMap.priority[control.priority] || 0) + 1;
    asmt.countMap.score[control.risk_score] =
      (asmt.countMap.score[control.risk_score] || 0) + 1;
    asmt.countMap.status[control.status] =
      (asmt.countMap.status[control.status] || 0) + 1;
    asmt.countMap.response[control.result_value] =
      (asmt.countMap.response[control.result_value] || 0) + 1;
  });
  if (Array.isArray(asmt.evidence_list)) {
    asmt.evidence_list = asmt.evidence_list
      .filter((item) => item[1])
      .map((item) => ({ id: item[1], label: item[0] }));
  }
  return asmt;
};
export function buildFormDataFromPayload(payload) {
  const fd = new FormData();

  (payload?.formdata || []).forEach((item) => {
    if (!item?.key) return;

    if (item.type === "file") {
      if (item.value instanceof File || item.value instanceof Blob) {
        fd.append(item.key, item.value);
      }
    } else {
      fd.append(item.key, item.value ?? "");
    }
  });

  // DEBUG: confirm files exist
  for (const [k, v] of fd.entries()) {
    console.log("FD:", k, v instanceof File ? `File(${v.name})` : v);
  }

  return fd;
}
export const mapReportListRow = (row) => ({
  ...row,
  user: row.user || "-",
  governor: row.governor || "-",
  report_date: formatDate(row?.report_date),
  framework: row.framework ?? row.title,
});

export const mapAuditDetailsToForm = (res) => {
  if (!res) return null;

  return {
    id: res?.id,
    blueprint: String(res?.lib1_model?.id || res?.lib1_model_id || ""),
    title: res?.title || "",
    description: res?.desc || "",
    audit_type: res?.audit_type || "",
    start_date: res?.start_date || "",
    end_date: res?.end_date || "",

    // report_format dropdown options are rf strings; set value as string
    report_format: res?.lib1_model?.report_format || res?.report_format || "",

    // ✅ Dropdown multiSelection expects array of ids
    governor: (res?.asmt_assessors || [])
      .map((x) => String(x?.assessor_id))
      .filter(Boolean),

    user: (res?.asmt_auditees || [])
      .map((x) => String(x?.auditee_id))
      .filter(Boolean),
  };
};

export const getAuditStatusList = (audit) => {
  if (!audit) {
    return AuditStatus;
  }
  return AuditStatus.filter((status) => {
    if (audit.status.toLowerCase() === "complete") {
      return ["revision", "complete"].indexOf(status.id.toLowerCase()) > -1;
    }
    if (audit.status.toLowerCase() === "revision") {
      return true;
    }
    return status.id.toLowerCase() !== "revision";
  });
};

export const getCurrentAudit = (state) => {
  return getAuditState(state).currentAudit;
};

export const getCurrentControl = (state) => {
  return getAuditState(state).currentControl;
};
